module.exports = __webpack_public_path__ + "img/wave-triangle.fd360d8f.svg";